export type GoogleIdentityResult = {
  idToken: string
}

export const signInWithGoogleIdentity = async (): Promise<GoogleIdentityResult> => {
  const clientId = import.meta.env.VITE_GOOGLE_CLIENT_ID?.trim()

  if (!clientId) {
    throw new Error('Google client id is not configured.')
  }

  const googleClient = window.google?.accounts?.id
  if (!googleClient) {
    throw new Error('Google Identity Services is not available.')
  }

  return new Promise<GoogleIdentityResult>((resolve, reject) => {
    let settled = false
    const timeout = window.setTimeout(() => {
      if (settled) {
        return
      }

      settled = true
      reject(new Error('Google sign-in timed out. Please try again.'))
    }, 15000)

    googleClient.initialize({
      client_id: clientId,
      callback: (response: GoogleCredentialResponse) => {
        if (settled) {
          return
        }

        const credential = response.credential
        if (!credential) {
          settled = true
          window.clearTimeout(timeout)
          reject(new Error('Google did not return an ID token.'))
          return
        }

        settled = true
        window.clearTimeout(timeout)
        resolve({ idToken: credential })
      }
    })

    googleClient.prompt()
  })
}
